import { axiosBasic, axiosBearer } from "../config/axios-common";
import ProfssionalPrivilege from "../models/ProfssionalPrivilege";

const postInsertOrUpdateProfssionalPrivilege = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/professionalPrivilege/insertOrUpdateProfessionalPrivilege?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

const CreateAndGetProfssionalPrivilegeFromTasy = async (requestId: string): Promise<ProfssionalPrivilege[]> => {

    const response = await axiosBearer.post(`/sam/v1/professionalPrivilege/CreateAndGetProfessionalPrivilegeFromTasy?requestId=${encodeURIComponent(requestId)}`, {}).then(response => {

        var result = new Array<ProfssionalPrivilege>();

        if (response.data !== undefined && response.data.length > 0) {

            result = response.data.map((row: any) => {
                let item = ProfssionalPrivilege.NewInstance();

                item.Id = row.id;
                item.Title = row.title;
                item.Privilege = row.privilege;
                item.PrivilegeDescription = row.privilegeDescription;
                item.TasyCode = row.tasyCode;
                item.RemoveTasy = row.removeTasy;

                return item;
            });
        }

        return result;
    })

    const responseData = await response;

    return responseData;

};




const exportedObject = {
    postInsertOrUpdateProfssionalPrivilege,
    CreateAndGetProfssionalPrivilegeFromTasy
};


export default exportedObject